import { createSelector } from "@ngrx/store";

import { Test9State } from "../reducers/test9.reducers";

export const selectFeature = (state: any) => state.test9;

export const selectMovies = createSelector(
  selectFeature,
  (state: Test9State) => state.movies
);

export const selectError = createSelector(
  selectFeature,
  (state: Test9State) => state.error
);

export const selectLoading = createSelector(
  selectFeature,
  (state: Test9State) => state.loading
);

